export function optimizedBenefitImageUrl(url: string): string {
    if (!url) return '';

    try {
        const path = new URL(url, window.location.origin).pathname;
        if (path === '/img/benefit/ozon.svg') return '/img/benefit/ozon.webp';
        if (path === '/img/benefit/BenefitOZON.png') return '/img/benefit/BenefitOZON.webp';
    } catch (error) {
        // Keep the original address if it cannot be parsed.
    }

    return url;
}
